'use client';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';
import TitleSection from '../layout/titles/TitleSection';
import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay, Pagination } from 'swiper/modules';
import { App_text } from '@/settings/AppText';

export default function BrandsSlide({ textContent }) {
    // Use textContent if provided, otherwise fallback to App_text
    const content = textContent || App_text.pages.home.section_services;

    return (
        <div className="relative bg-main-color">
            <div className="brand-one-shape bg-[url('/media/new/bg-brands.png')]"></div>
            <div className="relative px-4 py-10 mx-auto w-full max-w-8xl lg:px-6 sm:py-12 lg:py-20">
                <div className="relative z-[1] grid grid-cols-1 gap-4 lg:grid-cols-12 lg:items-center">
                    <div className="lg:col-span-4">
                        <TitleSection className="!text-white">{content.sitle_slide || content.title_slide}</TitleSection>
                    </div>
                    <div className="relative lg:col-span-8">
                        <Swiper
                            slidesPerView={2}
                            breakpoints={{
                                768: {
                                    slidesPerView: 3,
                                },
                                1024: {
                                    slidesPerView: 4,
                                },
                                1200: {
                                    slidesPerView: 5,
                                },
                            }}
                            slidesPerGroup={1}
                            spaceBetween={14}
                            autoplay={{
                                delay: 1500,
                                disableOnInteraction: false,
                            }}
                            speed={1000}
                            modules={[Autoplay, Pagination]}
                            className="brands-slide"
                        >
                            {(content.images || []).map((brand, index) => (
                                <SwiperSlide key={index}>
                                    <div className="flex justify-center items-center w-full h-28 sm:h-32">
                                        <img src={brand.src} alt={brand.alt} title={brand.alt} loading="lazy" width={240} height={120} className="object-contain max-w-full max-h-full" />
                                    </div>
                                </SwiperSlide>
                            ))}
                        </Swiper>
                    </div>
                </div>
            </div>
        </div>
    );
}
